import { Config } from '@topwrite/common';
import path from 'path';

export default function getFullPath(filename: string, root: string) {
    if (filename === Config.file) {
        return filename;
    }
    return path.join(root, filename);
}
